import {ColorType} from 'native-base/lib/typescript/components/types';
import {SemaphoreKeys} from '../enumerations';

const getSemaphoreColor = (key: SemaphoreKeys): ColorType => {
  switch (key) {
    case SemaphoreKeys.Green:
      return 'green.500';
    case SemaphoreKeys.Yellow:
      return 'yellow.300';
    case SemaphoreKeys.Orange:
      return 'orange.400';
    case SemaphoreKeys.Red:
      return 'red.600';
    default:
      return 'blue.400';
  }
};

export default getSemaphoreColor;
